import React, { ReactElement } from "react";
import {
  IconBellRinging,
  IconMemberDiscount,
  IconOnePassDelivery,
  IconOnePassTags,
} from "@catchoftheday/cg-components";

type OnePassBenefit = {
  icon: ReactElement;
  title: string;
  subtitle: string;
};

export const benefits: OnePassBenefit[] = [
  {
    icon: (
      <IconOnePassDelivery
        height="30px"
        width="auto"
        color="onePass.primaryDark"
      />
    ),
    title: "Free delivery",
    subtitle: "On thousands of eligible products",
  },
  {
    icon: (
      <IconMemberDiscount
        height="41px"
        width="auto"
        color="onePass.primaryDark"
      />
    ),
    title: "Member only pricing",
    subtitle: "Member prices on thousands of products",
  },
  {
    icon: (
      <IconOnePassTags height="40px" width="auto" color="onePass.primaryDark" />
    ),
    title: "Exclusive deals",
    subtitle: "Access to exclusive weekly deals",
  },
  {
    icon: (
      <IconBellRinging height="35px" width="auto" color="onePass.primaryDark" />
    ),
    title: "Early alerts for deals",
    subtitle: "Get priority alerts to the best deals",
  },
];
